<mat-nav-list class="manax-side-navbar" [class.manax-side-navbar-collapsed]="collapsed" (mouseleave)="onMouseMove(true)"
  (mouseenter)="onMouseMove()">

  <div class="nav-item simple-text text-left px-3" style="height: 65px;">
    <img class="Lavuro-logo" alt="Lavuro-logo">
  </div>

  <div class="navbar-user-profile d-block d-md-none" *ngIf="profile">

    <mat-form-field class="d-block d-md-none" style="min-width: 200px;">
      <mat-label>Empresa</mat-label>
      <mat-select [(ngModel)]='activeCompany' (ngModelChange)='onCompanyChange()'>
        <mat-option *ngFor="let company of companies; let i = index" [value]='i'>
          {{company.name}}
          <button type="button" class="btn btn-link text-lavuro pr-0 pull-right" *ngIf="i != activeCompany"
            (click)="onCompanyOpenNewWindow(i);">
            <i class="material-icons small" style="vertical-align: bottom;">launch</i>
          </button>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="d-block d-md-none" style="min-width: 200px;">
      <input matInput placeholder="Usuario" type="text" [(ngModel)]='profile.username' readonly />
    </mat-form-field>

  </div>

  <mat-list-item (click)="onCreateNew()" class="createBtn"
    style="margin-top: 5px !important;margin-bottom: 5px !important;">
    <mat-icon style="vertical-align: bottom; color: white !important;">add_circle</mat-icon>
    <span class="menu-label text-weight" style="color: white !important;" *ngIf="!collapsed">Crear Nuevo</span>
  </mat-list-item>
  <hr class="separator">

  <ng-container *ngFor="let menu of menuList; index as i;">
    <ng-container [ngTemplateOutlet]="menu.children ?  childMenu : parentMenu" [ngTemplateOutletContext]="{menu:menu}">
    </ng-container>
  </ng-container>

  <div class="col-12 mt-3" *ngIf="!collapsed && currentCompany?.isTrial">
    <div class="schedule-demo-box d-flex flex-column align-items-center justify-content-center"
      style="background-color: white;">
      <i class="material-icons text-lilac-manax" style="font-size: 3rem;">support_agent</i>
      <h5 class="schedule-demo-text">¿<span class="schedule-demo-bold">Necesitas una mano</span><br>
        para utilizar Manax?</h5>
      <button class="btn btn-outline-lilac-manax " style="width: 100% !important; font-weight: 600;"
        (click)="scheduleDemo()">
        Programar Demo
      </button>
    </div>
  </div>
</mat-nav-list>

<ng-template #parentMenu let-menu="menu">
  <mat-list-item (click)="onSelect()" [routerLink]="menu.routerLink" routerLinkActive="is-active"
    [routerLinkActiveOptions]="{exact: false}" *ngIf="!menu.hidden" [class]="menu.class">
    <mat-icon class="color-purple-manax" style="vertical-align: bottom;">{{menu.icon}}</mat-icon>
    <span class="menu-label text-weight color-purple-manax" *ngIf="!collapsed">{{menu.text}}</span>&nbsp;&nbsp;
    <!--span *ngIf="(menu.text == 'Solicitudes') && (unreadTaskRequestNotificationsCount > 0) && !collapsed">
      &nbsp;&nbsp;
    </span-->
    <span class="badge badge-pill badge-danger"
      *ngIf="(menu.text == 'Solicitudes') && (unreadTaskRequestNotificationsCount > 0)">
      {{pendingTaskRequestNotificationsCount}}
    </span>
  </mat-list-item>
  <hr *ngIf="menu.separator" class="separator">
</ng-template>

<ng-template #childMenu let-menu="menu">
  <mat-expansion-panel [class.mat-elevation-z0]="true" *ngIf="!menu.hidden" [expanded]="menu.opened"
    (opened)="setOpened(menu)" (click)="openMenu()">
    <mat-expansion-panel-header [class.is-active]="menu == selectedMenu" class="parent">
      <mat-icon class="color-purple-manax" style="vertical-align: bottom;">{{menu.icon}}</mat-icon>
      <span class="menu-label text-weight color-purple-manax" *ngIf="!collapsed">{{menu.text}}</span>
    </mat-expansion-panel-header>
    <mat-nav-list style="margin-top: 5px;">
      <mat-list-item (click)="onSelect(menu)" [routerLink]="submenu.routerLink" *ngFor="let submenu of menu.children"
        [class]="'submenu ' + menu.class" routerLinkActive="is-active" [routerLinkActiveOptions]="{exact:false}"
        class="child">
        <mat-icon class="color-purple-manax" style="vertical-align: bottom;">{{submenu.icon}}</mat-icon>
        <span class="menu-label text-weight color-purple-manax" *ngIf="!collapsed">{{submenu.text}}</span>
      </mat-list-item>
    </mat-nav-list>
  </mat-expansion-panel>
  <hr *ngIf="menu.separator" class="separator">
</ng-template>



<br><br>